import {RuleBundleType} from '@frontapp/workflows/rules';
import React, {FC} from 'react';

import {NewPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  ActivitySourceMacroModel,
  ActivitySourceRuleModel,
  ActivitySourceVisualTypesEnum,
} from '../../../../../models/api/activitySourceModel';
import {ActivityMacroPill} from './activityMacroPill';
import {ActivityRulePillContainer} from './activityRulePillContainer';

/*
 * Props.
 */

export interface ActivityRuleOrMacroPillProps {
  panelId?: NewPanelId;
  source: ActivitySourceRuleModel | ActivitySourceMacroModel;
  onClickTrackingCallback?: () => void;
}

/*
 * Component.
 */

export const ActivityRuleOrMacroPill: FC<ActivityRuleOrMacroPillProps> = ({
  panelId,
  source,
  onClickTrackingCallback,
}) => {
  if (
    source.visualType === ActivitySourceVisualTypesEnum.MACRO ||
    (source.visualType === ActivitySourceVisualTypesEnum.RULE &&
      source.ruleBundleType === RuleBundleType.MACRO)
  ) {
    return (
      <ActivityMacroPill
        panelId={panelId}
        source={source}
        onClickTrackingCallback={onClickTrackingCallback}
      />
    );
  }

  return (
    <ActivityRulePillContainer
      panelId={panelId}
      ruleId={source.ruleId}
      ruleName={source.ruleName}
      ruleBundleId={source.ruleBundleId}
      ruleBundleType={source.ruleBundleType}
      ruleNamespace={source.ruleNamespace}
      onClickTrackingCallback={onClickTrackingCallback}
    />
  );
};
